import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  FaPhone, 
  FaEnvelope, 
  FaMapMarkerAlt, 
  FaFacebook, 
  FaTiktok, 
  FaTruck,
  FaArrowRight
} from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const quickLinks = [
    { label: 'Accueil', to: '/', sectionId: null },
    { label: 'Services', to: '/#services', sectionId: 'services' },
    { label: 'Pourquoi nous', to: '/#why-us', sectionId: 'why-us' },
    { label: 'Paiement', to: '/#payment', sectionId: 'payment' },
    { label: 'Avis', to: '/#testimonials', sectionId: 'testimonials' },
    { label: 'Contact', to: '/#contact', sectionId: 'contact' }
  ];

  const services = [
    { label: 'Déménagement maison', to: '/#services', sectionId: 'services' },
    { label: 'Déménagement bureau', to: '/#services', sectionId: 'services' },
    { label: 'Transport de meubles', to: '/#services', sectionId: 'services' },
    { label: 'Transport longue distance', to: '/#services', sectionId: 'services' }
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Colonne 1 - Logo */}
        <div className="footer-col">
          <div className="footer-logo">
            <FaTruck className="logo-icon" />
            <span>SMTD</span>
          </div>
          <p className="footer-description">
            Votre partenaire de confiance pour tous vos déménagements et transports.
          </p>
          <div className="social-links">
            <a href="https://www.facebook.com/profile.php?id=61561067225767" target="_blank" rel="noopener noreferrer">
              <FaFacebook />
            </a>
            <a href="https://www.tiktok.com/@muss5827" target="_blank" rel="noopener noreferrer">
              <FaTiktok />
            </a>
          </div>
        </div>

        {/* Colonne 2 - Liens rapides */}
        <div className="footer-col">
          <h3>Liens rapides</h3>
          <ul>
            {quickLinks.map((link, index) => (
              <li key={index}>
                {isHomePage && link.sectionId ? (
                  <button 
                    onClick={(e) => {
                      e.preventDefault();
                      const element = document.getElementById(link.sectionId);
                      if (element) {
                        element.scrollIntoView({ behavior: 'smooth' });
                      }
                    }}
                    className="footer-link-btn"
                  >
                    <FaArrowRight className="link-icon" />
                    {link.label}
                  </button>
                ) : (
                  <Link to={link.to}>
                    <FaArrowRight className="link-icon" />
                    {link.label}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </div>

        {/* Colonne 3 - Services */}
        <div className="footer-col">
          <h3>Nos services</h3>
          <ul>
            {services.map((service, index) => (
              <li key={index}>
                {isHomePage ? (
                  <button 
                    onClick={(e) => {
                      e.preventDefault();
                      const element = document.getElementById(service.sectionId);
                      if (element) {
                        element.scrollIntoView({ behavior: 'smooth' });
                      }
                    }}
                    className="footer-link-btn"
                  >
                    <FaArrowRight className="link-icon" />
                    {service.label}
                  </button>
                ) : (
                  <Link to="/">
                    <FaArrowRight className="link-icon" />
                    {service.label}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </div>

        {/* Colonne 4 - Contact */}
        <div className="footer-col">
          <h3>Contact</h3>
          <ul className="contact-list">
            <li><FaPhone /> 07 55 13 40 87</li>
            <li><FaEnvelope /> smtdtrans@gmail.com</li>
            <li><FaMapMarkerAlt /> 10 Rue de la boulangerie, 93200 Saint-Denis, France</li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {currentYear} SMTD. Tous droits réservés.</p>
        <div className="footer-bottom-links">
          <p>Développé par ASBAI Rafik</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;